import * as tokenConfig from './config/token';
import * as token from '../auth/token';
import Klickart from './klickart';

const { REQUEST_BODY, MINUTES_TO_UPDATE, PATH } = tokenConfig;
const klickart = new Klickart();

export const get = () => klickart
  .post(PATH, REQUEST_BODY, {})
  .then((response) => {
    token.set(response.data.token);

    return response.data.token;
  });

export const autoUpdate = () => {
  setInterval(() => {
    get();
  }, 1000 * 60 * MINUTES_TO_UPDATE);
};



// WEBPACK FOOTER //
// ./src/services/request/token.js